export const REDIRECT_URLS = {
  "beta": "https://stage-sso.oto.com/google?redirect=",
  "preprod": "https://stage-sso.oto.com/google?redirect=",
  "prod": "https://sso.oto.com/google?redirect=",
  "local": "https://stage-sso.oto.com/google?redirect="
}


export const API_URL = {
    GETWAY_API: process.env.REACT_APP_GETWAY_API+'collectionbox/',
    GETWAY_DOCS_API: process.env.REACT_APP_GETWAY_API+'collectionbox/' 
};

export const APIV = 1; 
 
export const API_VERSION_V2 = 'v2';

export const REDIRECT_URL = REDIRECT_URLS[process.env.REACT_APP_ENV as keyof typeof REDIRECT_URLS || "local"];

export const KEY_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'outstanding',
  third: 'unpaid',
  fourth: 'expired'
};
export const DESCRIPTION_VALIDATION = {min: 3, max: 500}; 
export const ROLE_NAME_VALIDATION = {min: 3, max: 30 };


export const ROLE_FEATURES = {
  "Admin": 1,
  "Finance": 2,
  "Reconciliation": 3,
  "Collections":4,
  "Leads":5
}

export const DOC_UPLOAD_VALIDATION = {"minSize": 25000, "maxSize": 5000000}
export const AGENCY_STATUS = {
    "inactive":0,
    "active": 1, 
    "inprogress":2,
    "rejected": 3
}



export const CURRENCY_CODE = 'id-ID';
export const CURRENCY_SYMBOL = 'Rp';
export const APP_TYPE_AGENCY = 4;

export const USER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const USER_NAME_VALIDATION = {min: 3, max: 30 };
export const USERLIST_MOBILE_REGEX = /^[0-9]{9,12}$/;
export const USERLIST_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const USER_MOBILE_REGEX = /^[8]\d{7,11}$/;
export const USER_PASSWORD_REGEX = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE
export const ALLOW_ALPHABET = /^[A-Za-z\s]+$/
export const ALLOW_CHAR_NUM = /^[a-zA-Z0-9]+$/

export const KEY_RECONCILIATION_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'pending',
  third: 'verified',
  fourth: 'rejected'
};
export const KEY_PAYMENT_ACTIVE_TAB_MAP: Record<string, string> = {
  first: 'all',
  second: 'pending',
  third: 'verified',
  fourth: 'rejected'
};

export const MANAGER_LEVEL_IDS = [1,2,3]

export const RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES = /^[0-9]*\.?[0-9]{0,2}$/

export const ROLES = { ADMIN: 1, SALES_HEAD:2, SALES_MANAGER:3, COLLECTIONS_SALES_AGENT:4, FINANCE_TEAM:5, RECO_TEAM: 6, REM_OPS:22, REM_FINANCE_MAKER:23, REM_FINANCE_CHECKER:24};

export const PAYMENT_DISSABLE_STATUS = [2,3,5,6,8]

export const ALERT_STATUS = [2,5,3,4,6,7,8]

export const AGENT_LEAD_TYPES = [4]

export const PAYMENT_TYPE_RADIO = [1, 2]

export const ROLE_HIERARCHY: any = {
  'Admin': ['Admin'], // Admin reports to Admin
  'Sales Head': ['Admin'], // Sales Head reports to Admin
  'Sales Manager': ['Sales Head'], // Sales Manager reports to Sales Head
  'Collections Agent': ['Sales Manager'], // Collections Sales Agent reports to Sales Manager
  'Finance Team': ['Sales Manager'], // Finance Team reports to Sales Manager
  'Reco Team': ['Sales Manager'], // Reco Team reports to Sales Manager
  'Rem_Ops': ['Sales Manager'], // Rem_Ops Team reports to Sales Manager
  'Rem_Finance Maker': ['Sales Manager'], // Rem_Finance Maker reports to Sales Manager
  'Rem_Finance Checker': ['Sales Manager'] // Rem_Finance Checker reports to Sales Manager
};

export const LEAD_TYPE_WEB = 3
export const LEAD_TYPE_CRM = 4
export const DATE_RANGES = {
  NEXT_DAYS_7: 7,
  NEXT_DAYS_14: 14
};

export const CHEQUE_SLUG = "post-dated-cheque"
export const REGEX_ONLY_NUMBER = /^[0-9]+$/;
export const RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES = /^\d*(?:\.\d{0,4})?/

export const REMITTANCE_TYPE = {
  "partner" : "partner",
  "agency-commission" : "agency-commission",
  "agency-points"   : "agency-points"
}

export const LEAD_ASSIGN_TO  = { REM_OPS: "rem-ops", REM_FINANCE_MAKER: "rem-finance-maker",REM_FINANCE_CHECKER: "rem-finance-checker"}

export const OPS_ROLE_ID = 7
export const MAKER_ROLE_ID = 8
export const CHECKER_ROLE_ID = 9

export const LEAD_REMITTANCE_STATUS_MARK = {SEND_TO_MAKER : 1, BACK_TO_OPS: 2, MAKE_PAYMENT: 3, BACK_TO_MAKER: 4, COMPLETE: 5}
export const POST_DATED_CHEQUE_ID = 3


export const LEAD_TYPE_AGENT = 5

export const REMITTANCE_LEVEL_IDS = [7,8,9]

export const ADMIN_OPS_STATUS = [1, 2]
export const ADMIN_MAKER_STATUS = [3,4]
export const ADMIN_CHECKER_STATUS = [5]
export const ADMIN_CHECKER_COMPLETE_STATUS = [5,6]
export const   REMITTANCE_STATUS = {
  READY_FOR_OPS : 1,
  BACK_TO_OPS : 2,
  READY_FOR_MAKER : 3,
  BACK_TO_MAKER : 4,
  READY_FOR_CHECKER : 5,
  COMPLETE : 6
}
export const APP_COUNTRY = {APP_TYPE_ID:'id', APP_TYPE_PH:'ph'};

export const TRENCH_LIST = {
  "partner" : 1,
  "agency-commission" : 2,
  "agency-points" : 3
}

export const MAX_LEAD_ASSIGN_COUNT = 100

export const ROLE_SLUG_MAP = {
  "Rem_Ops": "rem-ops",
  "Rem_Finance Maker": "rem-finance-maker",
  "Rem_Finance Checker": "rem-finance-checker"
}

export const LEAD_LOST_ID = 6
export const LEAD_LOST_SUB_STATUS_ID = 18
export const MOBILE_NO_LENGTH = 12

export const FLAT_DISBURSMENT_FEES = 2775;
export const INSURER_STATUS ={
  INACTIVE:2
}
export const STATUS_SUCCESS = 200

export const ONLY_ALPHABET_REGEX = /^[A-Za-z\s]+$/;

export const PAYSO_QR_PAYMENT_ID = 5;

export const PARTNERS_ONLY_FOR_CREDIT_CARD = ["fpg","oona","mercantile","pioneer"];